import { TRESPONSE_LINE_LEVEL_STRIP_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTextCell } from '../../table.type';
import * as moment from 'moment';
import { DateUtils } from '@monorepo/utils';

const createHeaderRow = (headerInfo: TRESPONSE_LINE_LEVEL_STRIP_LIST['fieldInfo']): TTableOptions['headerConfig'] => {
  const headerRow = [
    ...headerInfo.map((hInfo) => {
      return {
        type: 'TEXT_CELL',
        text: hInfo['displayName'],
        widthInPx: hInfo.dataType === 'DATE' ? 100 : undefined,
      };
    }),
  ] as TTextCell[];
  return headerRow;
};

const getRows = (
  headerInfo: TRESPONSE_LINE_LEVEL_STRIP_LIST['fieldInfo'],
  rowItem: TRESPONSE_LINE_LEVEL_STRIP_LIST['strips'][number],
) => {
  const rows = [
    ...headerInfo.map((hInfo) => {
      return {
        type: 'TEXT_CELL',
        text:
          hInfo.dataType === 'DATE'
            ? rowItem['fields'][hInfo.key].map((x) => DateUtils.getDisplayDateStringFromDate(x))
            : rowItem['fields'][hInfo.key],
      };
    }),
  ] as TTableCellType[];

  return rows;
};

export const LINE_STRIP_LIST_PLANI8_TABLE_MODEL = {
  createModel: (
    headerInfo: TRESPONSE_LINE_LEVEL_STRIP_LIST['fieldInfo'],
    rowInfo: TRESPONSE_LINE_LEVEL_STRIP_LIST['strips'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        headerConfig: createHeaderRow(headerInfo),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: getRows(headerInfo, item),
        };
      },
    );
  },
};
